export const ROLE_TYPE = {
  noPermission: -1, // 无权限
  owner: 1,  // 所有者
  admin: 2, // 管理员
  developer: 0, // 开发者
};

export const ABILITY_LIST = {
  GroupTopCard: 1,
  GroupNotification: 2,
  LinkEnhancedCard: 3,
  SharetoMessage: 4,
  Wecode: 5
}

export const ERROR_CODE = {
  REPEAT: 58001,
  INVALID: 58002,
  LIMITED: 58003,
  BINDLIMIT: 58004,
  TYPELIMIT: 58005,
  NOTINTENANT: 58006,
  REPEATID: 58007,
  REPEATADMIN: 58008,
  NOTBINDEAMAP: 58009,

  PERSONALAPPLICATION: 400103, // 个人应用
  NOABILITY: 400401, // 没对应能力
  NEEDOWNER: 400302, // 无访问应用权限，请联系owner添加权限
  NEEDHISOWNER: 400303, // 无访问应用权限，请联系his应用责任人

  APPROVE_ERROR: 400600,
  APPROVE_NO_SUPPORT: 400601,
  APPROVE_NO_ENABLED: 400602,
  APPROVE_STATUS_NO_CHANGE: 400603,
  APPROVE_NO_SUPPORT_OPERATION: 400604,
  APPROVE_ID_EMPTY: 400605,
  APPROVE_STATUS_EMPTY: 400606,
  APPROVE_ID_NO_FUND: 400607,
  APPROVE_HAS_IN_PROCESS: 400608,
  APPROVE_NO_APPROVED: 400609,

  VERSION_INFO_ERROR: 400200,
  VERSION_NO_FUND: 400201,
  VERSION_STATUS_ERROR: 400202,
  VERSION_FORMAT_INVALID: 400203,
  VERSION_MAX: 400204,
  VERSION_UPDATE: 400205,
  VERSION_EXIST: 400206,
  VERSION_DELETE: 400207,
  VERSION_INTERVAL: 400208,
  VERSION_NO_AUTHOR: 400610
};

export const elfowStatus = {
  UNDERREVIEW: 2,
  REVIEWCOMPLETEDFAILED: 3, // 审批不通过的电子流
  REVIEWCOMPLETEDSUCCESS: 4, // 审批通过的电子流
}

export const docLinkUrl = {
  /** 
   * 事件通知为同一个链接，包括事件与回调中的了解更多
   * 接口回调四个能力共用一个链接*/ 
  inner: {
    eventNotification: '/i3s1q5/1a36rh/uanbvr', // 事件通知
    dataCallbackInterface: '/i3s1q5/1a36rh/t1yvzd', // 接口回调
    abilityDocUrl: [
      {
        developmentDocuments: '/i3s1q5/1a36rh/s2beqb', // 群置顶服务查看开发文档地址
        pushMethod: '/i3s1q5/1a36rh/1og2yx', // 群置顶服务推送方法
      },{
        developmentDocuments: '/i3s1q5/1a36rh/q3gyip', // 群通知服务查看开发文档地址
        pushMethod: '/i3s1q5/1a36rh/7huprp', // 群通知服务推送方法
      },{
        developmentDocuments: '/i3s1q5/1a36rh/hb315w', // 链接增强服务查看开发文档地址
        cardUpdateInterface: '/i3s1q5/1a36rh/r1idr3', // 链接增强服务卡片更新接口
      },{
        developmentDocuments: '/i3s1q5/1a36rh/j0dn5l', // 点对点服务查看开发文档地址
        pushMethod: '/i3s1q5/1a36rh/rrg16i', // 点对点服务推送方法
      }
    ],
  },
  uat: {
    eventNotification: '/yw3mtz/ptjrfk/uthtsp', // 事件通知
    dataCallbackInterface: '/yw3mtz/ptjrfk/wh6uvj', // 接口回调
    abilityDocUrl: [
      {
        developmentDocuments: '/yw3mtz/ptjrfk/2pr9u5', // 群置顶服务查看开发文档地址
        pushMethod: '/yw3mtz/ptjrfk/so9syt', // 群置顶服务推送方法
      },{
        developmentDocuments: '/yw3mtz/ptjrfk/zpud64', // 群通知服务查看开发文档地址
        pushMethod: '/yw3mtz/ptjrfk/1drowk', // 群通知服务推送方法
      },{
        developmentDocuments: '/yw3mtz/ptjrfk/truyjh', // 链接增强服务查看开发文档地址
        cardUpdateInterface: '/yw3mtz/ptjrfk/8qrdz5', // 链接增强服务卡片更新接口
      },{
        developmentDocuments: '/yw3mtz/ptjrfk/2z72vo', // 点对点服务查看开发文档地址
        pushMethod: '/yw3mtz/ptjrfk/9sfnx2', // 点对点服务推送方法
      }
    ]
  }
}
